import { createReducer, on } from '@ngrx/store';
import * as fromClientsControlActions from '../actions/clients-control.actions';
import { ClientControl } from 'src/app/models/client-control.model';

export interface ClientsControlState {
  data: ClientControl;
  loaded: boolean;
  loading: boolean;
  error: string;
}

export const initialState: ClientsControlState = {
  data: undefined as any,
  loaded: false,
  loading: false,
  error: ''
};

export const clientsControlReducer = createReducer(
  initialState,
  on(fromClientsControlActions.FetchClientsControlAction, (state) => ({
    ...state,
    loading: true,
    loaded: false
  })),
  on(
    fromClientsControlActions.FetchClientsControlSuccessAction,
    (state, { data }) => ({
      ...state,
      data,
      loading: false,
      loaded: true
    })
  ),
  on(
    fromClientsControlActions.FetchClientsControlFailAction,
    (state, { error }) => ({
      ...state,
      error: error.message,
      loading: false,
      loaded: true
    })
  )
);
